import { render, staticRenderFns } from "./bing.vue?vue&type=template&id=efce96b0&scoped=true"
import script from "./bing.vue?vue&type=script&lang=js"
export * from "./bing.vue?vue&type=script&lang=js"
import style0 from "./bing.vue?vue&type=style&index=0&id=efce96b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efce96b0",
  null
  
)

export default component.exports